/**
 * @generated SignedSource<<36a45a7e070ad5bbaf13b28fa2648b1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type requestPasswordResetInput = {
  clientMutationId?: string | null;
  email: string;
};
export type RequestPasswordResetMutation$variables = {
  input: requestPasswordResetInput;
};
export type RequestPasswordResetMutation$data = {
  readonly requestPasswordReset: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message?: string;
    }>;
    readonly success: boolean | null;
  } | null;
};
export type RequestPasswordResetMutation = {
  response: RequestPasswordResetMutation$data;
  variables: RequestPasswordResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "requestPasswordResetPayload",
    "kind": "LinkedField",
    "name": "requestPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "UserError",
            "abstractKey": "__isUserError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestPasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestPasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02becdce6383ace3d7a2fe4b437ccb38",
    "id": null,
    "metadata": {},
    "name": "RequestPasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation RequestPasswordResetMutation(\n  $input: requestPasswordResetInput!\n) {\n  requestPasswordReset(input: $input) {\n    success\n    errors {\n      __typename\n      ... on UserError {\n        __isUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53f0828b4b9a24e756e7f183dc3c6d1c";

export default node;
